export const DEFAULT_USD_PRICE_SCALE = 4;
export const DEFAULT_USD_PRICE_FACTOR = 1e4;
export const DEFAULT_MONEY_PRECISION = 2;

export const PILOT_CONTRACT_MARKER_FEE = 0.0004;
export const PILOT_CONTRACT_TAKER_FEE = 0.001;
